import RoutesMap from '../../route_control/RouteControl'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Dropdown } from 'antd'
import img_nf from '../../assets/images/default.jpg'
import SessionManager from '../../utils/sessionManager'
import { KeyRound, Languages, ListCollapse, Power, UserPen } from 'lucide-react'
import ChangePassword from '../../pages/user/change_password/ChangePassword'
import { toggleChangePasswordModal } from '../../redux/slices/globalSlice'
import { useTranslation } from 'react-i18next'

export const HeaderImport = {
    RoutesMap,
    useNavigate,
    useDispatch,
    Dropdown,
    img_nf,
    SessionManager,
    KeyRound,
    Languages,
    ListCollapse,
    Power,
    UserPen,
    ChangePassword,
    toggleChangePasswordModal,
    useTranslation
}